
import axios from 'axios';
// 序列化
import qs from 'qs';

import {setCookie, getCookie, delCookie} from '../common/_cookie';

const root = process.env.API_ROOT;
// 配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 配置请求超时
axios.defaults.timeout = 10000;

// 参数格式化
function formatQuery(str) {
  let ary = str.split('&')
  let obj = {}
  ary.forEach((v, i) => {
      let result = v.split('=')
      obj[result[0]] = result[1]
  })
  return obj
}

// http request 请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.method == 'post') {
      let liteToken = getCookie('ECS[litetoken]')
      if(liteToken != null && liteToken != '') {
        config.headers['X-ECAPI-Authorization'] = liteToken
      }   
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
)

// http response 响应拦截器
axios.interceptors.response.use(
  response => {
    // 200 请求成功
    if (response.status === 200 || response.error_code === 0) {
      if (response.data.code == 1 || response.data.code == 0) {
        return Promise.resolve(response)
      } else if (response.data.code === 10001) {
        // 请求成功，未登陆
        let url    = window.location.origin
        let base   = process.env.ACCOUNT_ROOT
        let login  = 'http://' + base +'/member.php?mod=logging&action=login'
        login     += '&callback=' +  url
        window.location.href = login
      } else {
        return Promise.reject(response)
      }
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    if (typeof error != 'undefined') {
      return Promise.reject(error);
    }
  }
);

function apiAxios(method, url, params, response) {
  let opt = params
  let config = {
    method: method,
    baseURL: root,
    url: url ,
    // 判断是否有自定义头部，以对参数进行序列化。不定义头部，默认对参数序列化为查询字符串。
    data: method === 'POST' || method === 'PUT' ? (opt.headers ? opt.data : qs.stringify(opt)) || {} : null,
    params: method === 'GET' || method === 'DELETE' ? (opt.headers ? opt.data : opt) || {} : null,
    responseType: opt.dataType || 'json',
    onUploadProgress: opt.onUploadProgress || null
  }
  if ( method == 'POST' ) {
    // post设置请求头
    config['headers'] = opt.headers || {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
  }
  axios(config)
  .then(function (res) {
    if (res.data.code === 1 && res.status === 200) {
      response(res.data);
    } else {
      if ( typeof res.data.error_code == 'undefined' || res.data.error_code == 0) {
        response(res.data);
        console.log('result data is not data.error_code');
      }
      if ( typeof res.status == 'undefined' || res.status != 200) {
        console.log('result data is not status');
      }
      // console.log(res)
    }
  }).catch(function (err) {
    console.log(err);
  })
}

export default {
  get: function (url, params, response) {
    return apiAxios('GET', url, params, response)
  },
  post: function (url, params, response) {
    return apiAxios('POST', url, params, response)
  },
  put: function (url, params, response) {
    return apiAxios('PUT', url, params, response)
  },
  delete: function (url, params, response) {
    return apiAxios('DELETE', url, params, response)
  }
}


// WEBPACK FOOTER //
// ./src/api/api.js